import { Navigate, Outlet, useParams } from "react-router-dom";

import { getPagePath, PAGES } from "@/config/pages";
import { isSupportedLanguage } from "@/i18n/routing";
import { useOrganisationStore } from "@/stores/OrganisationStore";

const OnboardingRoute = () => {
  const { lang } = useParams<{ lang: string }>();
  const { organisation } = useOrganisationStore();

  const eventsPath = isSupportedLanguage(lang)
    ? getPagePath("events", lang)
    : PAGES.events;

  if (organisation) {
    return <Navigate to={eventsPath} replace />;
  }

  return <Outlet />;
};

export default OnboardingRoute;
